import styles from "./toggelSwicther.module.scss";

export default function ToggleSwitch({
  isChecked,
  setIsChecked,
  firstVal,
  secondIcon,
  secondVal,
  pricingPage,
}) {
  return (
    <>
      <div className={`${styles["toggleSwitchContainer"]}`}>
        <div className={`${styles["toggleSwitch"]}`}>
          <input
            type="radio"
            id="secondVal"
            name="toggle"
            checked={!isChecked}
            onChange={() => setIsChecked(false)}
          />
          <label
            htmlFor="secondVal"
            className={`${isChecked ? "" : styles["active"]}`}
          >
            {secondIcon}
            {secondVal}
          </label>
          <input
            type="radio"
            id="firstVal"
            name="toggle"
            checked={isChecked}
            onChange={() => setIsChecked(true)}
          />
          <label htmlFor="firstVal">
            {firstVal}

            {pricingPage && (
              <div className={`${styles["offerText"]}`}>
                <span>Save 40%</span>
              </div>
            )}
          </label>
          <div className={`${styles["switch"]}`}></div>
        </div>
      </div>
    </>
  );
}
